import ECheckRowMobile from './ECheckRowMobile';

export default ECheckRowMobile;
